<template>
        <div class="row justify-content-center">
            <div class="col-lg-5 col-md-7">
                <div class="card bg-secondary shadow border-0">
                    <div class="card-header bg-transparent pb-5">
                        <div class="text-muted text-center mt-2 mb-3"><h2>Recuperar contraseña</h2></div>
                        <div class="btn-wrapper text-center">
                            
                        </div>
                    </div>
                    <div class="card-body px-lg-5 py-lg-5">
                        <div class="text-center text-muted mb-4">
                            <small>Introduce el correo electrónico de tu cuenta:</small>
                        </div>
                        <form role="form" @submit.prevent="restorepassword">
                            <base-input class="input-group-alternative mb-3"
                                        placeholder="correo@electronico.com"
                                        addon-left-icon="ni ni-email-83"
                                        v-model="email">
                            </base-input>

                            <div class="text-center">
                                <input class="form-submit my-4" type="submit" value="Enviar email de recuperación">
                            </div>
                        </form>
                    </div>
                </div>
                <div class="row mt-3">
                     <div class="col-6">
                        <router-link to="/login" class="text-light"><small>Iniciar sesión</small></router-link>                        
                    </div>
                    <div class="col-6 text-right">
                        <router-link to="/register" class="text-light"><small>Registro</small></router-link>
                    </div>
                </div>
            </div>
        </div>
</template>
<script>
import { auth } from '../firebaseDb';
  export default {

    name: 'login',
    data() {
      return {
          email: '',
          password: ''
        
      }
    },
    methods: {
        restorepassword(){
            auth.sendPasswordResetEmail(this.email)
        .then(() => {
            alert('Comprueba tu correo electrónico para restaurar tu contraseña.')
            this.user = {   
              email: ''
            }
        }).catch((error) => {
          alert(error)
        })
        }
    }
  }
</script>
<style>
</style>
